import { customerMarketShopfrontApi } from '@envato/foundation-types'

import {
  ActionTypes as CategoryPageActionTypes,
  TypeKeys as CategoryPageTypeKeys
} from '../actions/categoryPage'

export interface IState
  extends customerMarketShopfrontApi.categoryPage.IResult {
  isLoading: boolean
}

const initialState: IState = {
  metadata: {
    title: '',
    description: '',
    heading: '',
    sub_heading: ''
  },
  category: '',
  blocks: [],
  isLoading: false
}

export const reducer = (
  state = initialState,
  action: CategoryPageActionTypes
): IState => {
  switch (action.type) {
    case CategoryPageTypeKeys.GET_CATEGORY_PAGE_API_REQUEST:
      return {
        ...state,
        metadata: initialState.metadata,
        category: initialState.category,
        blocks: initialState.blocks,
        isLoading: true
      }

    case CategoryPageTypeKeys.GET_CATEGORY_PAGE_API_SUCCESS:
      const { metadata, category, blocks } = action.payload

      return {
        metadata,
        category,
        blocks,
        isLoading: false
      }

    case CategoryPageTypeKeys.GET_CATEGORY_PAGE_API_FAIL:
      return {
        ...state,
        isLoading: false
      }

    default:
      return state
  }
}
